import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 48 48"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M28.093 34.004a.89.89 0 0 1 .767-.484 181 181 0 0 0 8.407-.416 4.43 4.43 0 0 0 4.093-4.031q.367-4.164.367-8.755a100 100 0 0 0-.364-8.722 4.43 4.43 0 0 0-4.101-4.033q-7.614-.54-13.205-.54-5.605 0-13.317.543A4.43 4.43 0 0 0 6.637 11.6a100 100 0 0 0-.364 8.718q0 4.586.366 8.745a4.43 4.43 0 0 0 4.098 4.031q4.234.304 8.4.419a.89.89 0 0 1 .766.484l3.307 6.5a.886.886 0 0 0 1.58 0zm-1.723 7.297a2.66 2.66 0 0 1-4.74 0l-3.068-6.032a193 193 0 0 1-7.952-.406 6.204 6.204 0 0 1-5.737-5.644 102 102 0 0 1-.373-8.9q0-4.65.371-8.874a6.205 6.205 0 0 1 5.744-5.647q7.77-.548 13.442-.548 5.658 0 13.33.545a6.205 6.205 0 0 1 5.742 5.646q.37 4.229.371 8.877 0 4.668-.374 8.91a6.204 6.204 0 0 1-5.73 5.644 182 182 0 0 1-7.962.406zm-9.46-27.22h14.18c1.183 0 1.183 1.774 0 1.774H16.91c-1.183 0-1.183-1.773 0-1.773m0 5.319h14.18c1.183 0 1.183 1.773 0 1.773H16.91c-1.183 0-1.183-1.773 0-1.773m0 5.318h6.204c1.181 0 1.181 1.773 0 1.773h-6.205c-1.182 0-1.182-1.773 0-1.773",
      clipRule: "evenodd"
    }
  )
);
var SvgContactOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var ContactOutlined_default = SvgContactOutlined;

export { ContactOutlined_default as default };
